import React from 'react';

const DashboardPreview = () => {
  return (
    <div className="bg-white p-8 rounded-xl shadow-lg">
      <div className="mb-8">
        <h2 className="text-2xl font-semibold mb-2">Hola Frank</h2>
        <p className="text-gray-600">Esta es tu actividad del período: Del 05-03-2024 al 06-03-2024</p>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-gray-50 p-6 rounded-lg">
          <p className="text-gray-600 mb-2">Mensajes recibidos</p>
          <p className="text-3xl font-bold">112,000</p>
          <p className="text-green-500 text-sm mt-2">↑15% vs mes anterior</p>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg">
          <p className="text-gray-600 mb-2">Cotizaciones solicitadas</p>
          <p className="text-3xl font-bold">72,000</p>
          <p className="text-red-500 text-sm mt-2">↓8% vs mes anterior</p>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg">
          <p className="text-gray-600 mb-2">Cotizaciones enviadas</p>
          <p className="text-3xl font-bold">64,800</p>
          <p className="text-green-500 text-sm mt-2">↑12% vs mes anterior</p>
        </div>
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Pie Chart */}
        <div className="bg-gray-50 p-6 rounded-lg">
          <h3 className="text-lg font-semibold mb-4">Mensajes entrantes por tipo</h3>
          <div className="aspect-square relative">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-48 h-48 rounded-full border-8 border-primary-500 relative">
                <div className="absolute inset-0 border-8 border-blue-400 rounded-full" style={{ clipPath: 'polygon(0 0, 100% 0, 100% 70%, 0 70%)' }}></div>
                <div className="absolute inset-0 border-8 border-yellow-400 rounded-full" style={{ clipPath: 'polygon(0 70%, 100% 70%, 100% 85%, 0 85%)' }}></div>
                <div className="absolute inset-0 border-8 border-green-400 rounded-full" style={{ clipPath: 'polygon(0 85%, 100% 85%, 100% 100%, 0 100%)' }}></div>
              </div>
            </div>
          </div>
          <div className="flex justify-center gap-4 mt-4">
            <span className="flex items-center"><span className="w-3 h-3 bg-primary-500 rounded-full mr-2"></span>Cotizaciones</span>
            <span className="flex items-center"><span className="w-3 h-3 bg-blue-400 rounded-full mr-2"></span>Actualizaciones</span>
            <span className="flex items-center"><span className="w-3 h-3 bg-yellow-400 rounded-full mr-2"></span>Otros</span>
          </div>
        </div>

        {/* Bar Chart */}
        <div className="bg-gray-50 p-6 rounded-lg">
          <h3 className="text-lg font-semibold mb-4">Volumen de mensajes por día</h3>
          <div className="h-64 flex items-end gap-2">
            {[60, 45, 75, 50, 80, 65, 90, 70, 85, 55, 95, 60].map((height, index) => (
              <div key={index} className="flex-1 flex flex-col items-stretch gap-1">
                <div className="flex-1 bg-gray-100 relative">
                  <div 
                    className="absolute bottom-0 left-0 right-0 bg-primary-500 transition-all duration-500"
                    style={{ height: `${height}%` }}
                  ></div>
                </div>
                <span className="text-xs text-gray-500">{index + 1}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPreview; 